import { render } from "./TestStartScreen.vue?vue&type=template&id=19199744"
import script from "./TestStartScreen.vue?vue&type=script&lang=js"
export * from "./TestStartScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__